import { Injectable } from '@angular/core';
import { HttpService, ResponseType } from '../http/http.service';
import { UrlService } from '../url/url.service';
import { catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomerLocationsService {
  constructor(private _urlService: UrlService, private _httpService: HttpService) {}

  listHistory(endpoint: string, idTrade: string) {
    const url = this._urlService.getUrl(endpoint + '.historyCustomerLocations', { idTrade });
    return this._httpService.get(url, null).pipe(catchError((error: any) => throwError(error)));
  }

  updateLocation(endpoint: string, idTrade: string, informations: any) {
    const url = this._urlService.getUrl(endpoint + '.updateCustomerLocation', {});
    return this._httpService
      .put(url, { customer: { ...informations }, idTrade })
      .pipe(catchError((error: any) => throwError(error)));
  }
}
